import { ThemeProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import React from "react";

import { COLORS, SPACING } from "../theme/commonStyles";
import theme from "../theme/theme";
import GlobalCssPriority from "./GlobalCssPriority";
import PlainCssPriority from "./PlainCssPriority";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

const myTheme = {
  ...theme,
  colors: COLORS,
  sizes: SPACING,
};

const AllContextProvider = ({ children }) => {
  return (
    <MuiThemeProvider theme={myTheme}>
      <ThemeProvider theme={myTheme}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <CssBaseline />
          <GlobalCssPriority>
            <PlainCssPriority>{children}</PlainCssPriority>
          </GlobalCssPriority>
        </LocalizationProvider>
      </ThemeProvider>
    </MuiThemeProvider>
  );
};

export default AllContextProvider;
